<template>
  <!-- 弹框组件 -->
  <el-dialog custom-class="attr-pop" :title="attrTitle" :visible.sync="showPopAttr" :before-close="hidePopAttr" :modal-append-to-body="false">
    <el-scrollbar style="height:100%">
      <el-form ref="form" :model="attrData">
        <el-form-item label="用户昵称">{{attrData.username}}
        </el-form-item>
        <el-form-item label="下单时间">{{attrData.buy_time}}
        </el-form-item>
        <el-form-item v-if="attrData.pay_type" label="支付方式">{{attrData.pay_type}}
        </el-form-item>
        <el-form-item v-if="attrData.pay_no" label="支付流水号">{{attrData.pay_no}}
        </el-form-item>
        <el-form-item v-if="attrData.paytime" label="付款时间">{{attrData.paytime}}
        </el-form-item>
        <el-form-item v-if="attrData.is_refund" label="是否退款">{{attrData.is_refund}}
        </el-form-item>
        <el-form-item v-if="attrData.expresstime" class="top-line" label="发货时间">{{attrData.expresstime}}
        </el-form-item>
        <el-form-item v-if="attrData.confirm_time" label="收货时间">{{attrData.confirm_time}}
        </el-form-item>
        <el-form-item label="订单金额">{{attrData.orderprice}}
        </el-form-item>

        <el-form-item class="top-line" label="优惠金额" v-if="attrData.coupon.data.length!=0">{{attrData.couponprice}}
        </el-form-item>
        <div v-if="attrData.coupon.data.length!=0" v-for="(item,index) in attrData.coupon.data">
          <el-form-item label="优惠券编号">{{item.couponname}}
          </el-form-item>
          <el-form-item label="优惠券名称">{{item.couponno}}
          </el-form-item>
        </div>

      </el-form>
    </el-scrollbar>
  </el-dialog>
  <!-- <el-form-item label="商品名称">{{attrData.goodsName}}
        </el-form-item> -->
  <!-- <el-form-item label="商品件数">{{attrData.goodsNum}}
        </el-form-item> -->
</template>

<style lang="less">
.el-dialog.attr-pop {
  width: 502px;
  height: auto;
  max-height: 730px;
  padding: 20px;
  background-color: #ffffff;
  .el-dialog__header {
    padding: 0;
    padding-bottom: 20px;
    text-align: left;
  }
  .el-dialog__title {
    height: 15px;
    font-size: 16px;
    text-align: left;
    line-height: 15px;
    color: #081234;
    font-weight: bold;
    padding-left: 6px;
    margin-bottom: 18px;
    border-left: 5px solid #2e71fe;
  }
  .el-dialog__body {
    padding: 0;
    height: calc(100vh - 400px);
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
    .el-scrollbar__thumb {
      background-color: #c5c5c5;
    }
  }
  .el-form {
    padding: 20px 30px;
    border-top: 1px solid #f6f8fb;
    .el-form-item {
      margin-bottom: 0;
      .el-form-item__label {
        font-weight: bold;
        color: #081234;
      }
      .el-form-item__content {
        color: #8d8f96;
        text-align: left;
      }
    }
    .top-line {
      margin-top: 15px;
      padding-top: 8px;
      border-top: 1px solid #f6f8fb;
    }
  }
}
</style>

<script>
export default {
  props: ["showPopAttr", "attrData", "param"],
  data() {
    return {
      attrTitle: "",
      orderAttrId: "",
      orderAttr: {}
    };
  },
  watch: {
    attrData(obj) {
      // console.log(obj.expresstime);
    },
    param() {}
  },
  mounted() {
    this.orderAttrId = this.param.order_id;
    this.attrTitle = "订单编号" + this.orderAttrId;
  },
  methods: {
    hidePopAttr() {
      this.$emit("popAttrfn", false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/popover/popAttr.vue